import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import * as actionCreators from '../actionCreators';
import TouchGesture, { DIRECTION_LEFT, DIRECTION_RIGHT, } from '../components/TouchGesture';
function mapStateToProps(state) {
    return {
        isEnabled: !state.project.isLoading &&
            state.deviceDetection.hasTouch &&
            state.project.config.swipeThroughScreens,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSwipeHorizontally: function (_a) {
            var direction = _a.direction;
            if (direction === DIRECTION_LEFT) {
                dispatch(actionCreators.showNext('pushright', { swipeNavigation: [] }));
            }
            else if (direction === DIRECTION_RIGHT) {
                dispatch(actionCreators.showPrevious('pushleft', { swipeNavigation: [] }));
            }
        },
    };
}
function SwipeThroughScreens(_a) {
    var isEnabled = _a.isEnabled, onSwipeHorizontally = _a.onSwipeHorizontally, children = _a.children;
    if (!isEnabled) {
        return children;
    }
    return (React.createElement(TouchGesture, { action: "swipehorizontally", eventHandler: onSwipeHorizontally }, children));
}
SwipeThroughScreens.propTypes = {
    isEnabled: PropTypes.bool.isRequired,
    onSwipeHorizontally: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(SwipeThroughScreens);
